import { render, staticRenderFns } from "./c-control-panel-dialog.vue?vue&type=template&id=24dd3247&"
import script from "./c-control-panel-dialog.vue?vue&type=script&lang=js&"
export * from "./c-control-panel-dialog.vue?vue&type=script&lang=js&"
import style0 from "./c-control-panel-dialog.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports